export default __webpack_public_path__ + "static/media/Grid2.ac44489d.svg";